import { connect } from 'react-redux';
import NewSiteAssetMapping from "./newSiteAssetMapping";
import { bindActionCreators } from 'redux';
import {
  getParentMaterialsBySiteId,
  getAssetsAndMakeData,
  saveSitesAssetsGateWise
} from 'services/redux/installation/siteListing/action';
import { documentUploadUrl } from "services/redux/fileUpload/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    parentMaterials: state.siteListingReducer.parentMaterialsData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getParentMaterialsBySiteId,
      getAssetsAndMakeData,
      documentUploadUrl,
      documentUploadUrlPublic,
      saveSitesAssetsGateWise
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(NewSiteAssetMapping);
